import { useContext } from 'react';
import { ProviderContext } from '../context/provider.context';

export const useAuth = () => {
  return useContext(ProviderContext);
};
